module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic37.fdccea7.woff2";